import Icon from "./Icon";
import Modal from "./Modal";

export {
    Icon,
    Modal
}